module.exports = __webpack_public_path__ + "static/img/heavy-modular-frame_256.e9f8cc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/heavy-modular-frame_256.png
// module id = Utjg
// module chunks = 0